import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';

const ProgramsPlugin = React.lazy(() => importFromS3('tcc-programs-plugin'));

type Props = {
  isPluginEnabled?: boolean
}

export const ProgramsPluginContainer: React.FC<Props> = () => (
  <ProgramsPlugin />
);
